// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"656": "b199a7de2e318142","740": "0e3a17bedb00baf9","824": "8e7dd61da8ed0ab2","920": "f81fb87edbbdc432",}[chunkId] + ".js"
}